define('AwaLabs.QuickAddOnPDP', [
    'QuickAddOnPDP.View'
], function AwaLabsQuickAddOnPDP(
    QuickAddOnPDPView
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            var pdp = application.getComponent('PDP');
            var layout = application.getComponent('Layout');
            if (pdp) {
                pdp.addChildViews(
                    pdp.PDP_FULL_VIEW, {
                        'QuickAddButton': function LoyaltyPricePDPViewFn() {
                            return new QuickAddOnPDPView({
                                application: application
                            });
                        }
                    }
                );
                if (layout) {
                    layout.addToViewContextDefinition('ProductDetails.Quantity.View', 'addACase', 'boolean', function productDetailsQuantityFn(context) {
                        var item = context.model && context.model.item;
                        this.stockInfo = pdp.getStockInfo();
                        this.internalId = item && item.internalid;
                        this.saleUnit = item && item.saleunit;
                        this.caseSize = item && item.custitem_nspos_casesize;
                        this.addACase = null;
                        if (!((this.stockInfo && this.stockInfo.showOutOfStockMessage) || (this.stockInfo && this.stockInfo.isNotAvailableInStore))) {
                            if (this.internalId && this.saleUnit && this.caseSize) {
                                if (this.saleUnit === 'Unit') {
                                    if (this.caseSize !== 1) {
                                        this.addACase = this.caseSize;
                                    }
                                } else {
                                    this.saleUnit = this.saleUnit.substr(0, this.saleUnit.indexOf(' '));
                                    this.saleUnit = Number(this.saleUnit);
                                    if (this.caseSize !== this.saleUnit) {
                                        this.addACase = this.caseSize / this.saleUnit;
                                    }
                                }
                            }
                        }
                        return !!this.addACase;
                    });
                }
            }
        }
    };
});
